<template>
    <aside id="popup-step-02" class="layout-coldstart mfp-hide" data-layout-column>
        <header class="coldstart-hello">
            <h2 class="title">{{$t('COLDSTART.POPUP.SECOND.TITLE')}} <!--정책타입 선택--></h2>
            <p class="desc">
                {{$t('COLDSTART.POPUP.SECOND.DESC')}}<!--검사할 정책의 타입을 선택 해상세정보를 확인해 보세요.-->
            </p>

            <ul class="list-select-type">
                <li v-for="(ctg, idx) of dflCtgList" :key="idx"
                    v-bind:class="selCtg == ctg.ctgId ? 'selected' : null"
                    v-on:click="changePolicyType(ctg.ctgId)">
                    <button type="button" class="btn" v-bind:data-icon="ctg.ctgId">{{ctg.ctgLabel}}</button>
                </li>
            </ul>
        </header>


        <div class="coldstart-contetns">
            <div-loading v-if="pending" :full="false"></div-loading>
            <div v-else class="scroll">
                <ul class="list-policy">
                    <li v-for="(plcy, idx) in getPolicyList" v-on:click="selectPolicy(plcy)" v-bind:class="selPlcy == plcy ? 'selected' : null" :key="idx">
                        <button type="button" class="policy-item">
                            <div class="title">
                                <span v-for="vendor in plcy.vendor" :key="vendor" :data-vendor="Common.getVendorByKey(vendor)" class="icon-vender txt-none" data-size="m"/>
                                <span class="name" v-bind:title="plcy.titl">{{plcy.userDefiYn === constants.PARAM.SELECT.N ? plcy[$i18n.locale+"Title"] : plcy.titl}}</span>
                            </div>
                            <span class="desc" v-bind:title="plcy.desc">{{plcy.userDefiYn === constants.PARAM.SELECT.N ? plcy[$i18n.locale+"Desc"] : plcy.desc}}</span>
                            <div class="actions">
                                <span class="icon-tag" data-type="rules">{{plcy.ruleCnt}} {{$t('COMMON.UNIT.EA')}}</span>
                            </div>
                        </button>
                    </li>
                </ul>
            </div>

        </div>


        <div class="coldstart-actions">
            <div class="stack-item">
                <a :href="urls.portalUrl+'/docs/console/en/user-guide-console-en.html'" target="_blank" class="buttons" data-type="ghost" data-icon-right="open"><span class="link">{{$t('COLDSTART.BUTTON.VIEW_HELP')}}<!--도움말 보기--></span></a>
            </div>
            <div class="stack-item">
                <button type="button" class="buttons" data-type="ghost" v-on:click="finishColdstart()" :disabled="pending ? true : null"><span class="link">{{$t('COLDSTART.BUTTON.SKIP')}}<!--건너뛰기--></span></button>
                <button type="button" class="buttons" data-type="key" v-on:click="startColdstartPolicy()" :disabled="!selPlcy">{{$t('COLDSTART.BUTTON.EVALUATE')}}</button>
            </div>
        </div>
    </aside>
</template>
<script>
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: 'popColdstartStepSecond',
        data : function(){
            return {
                dflCtgList : [],
                plcyList : [],

                selCtg: null,
                selPlcy: null,

                pending: false,
            }
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getPolicyList: function(){
                let self = this;
                let list = _.filter(self.plcyList, {'dflCtgId' : self.selCtg});
                return list;

            },
        },
        methods: {
             ...mapMutations({

                setPolicyHistory: "user/setPolicyHistory"

            }),
            selectPolicy(plcy){
                this.selPlcy = plcy
            },
            changePolicyType(ctgId){
                this.selCtg = ctgId;
                this.selPlcy = null;
            },
            openPopup(){
                this.Common.viewPopup('popup-step-02');
                this.selectBestPracticePolicyList();
            },
            closePopup(){
                this.Common.closePopup();
            },
            selectBestPracticePolicyList(){
                this.dflCtgList = [];
                this.pending = true;
                let url = `/api/governance/coldstart/bestpractice`;
                this.http.get(url)
                    .then(response=>{
                        this.pending = false;
                        if(response.data.result){
                            if(response.data.result.list && response.data.result.list.length>0){
                                this.plcyList = response.data.result.list;
                                let self = this;

                                let tmpCtg = Object.keys(_.groupBy(self.plcyList, 'dflCtgId'));
                                _.forEach(tmpCtg, function(o){
                                    let findIndex = _.findIndex(self.plcyList, {'dflCtgId' : o});
                                    if(findIndex > -1){
                                        let obj = {
                                            ctgId : self.plcyList[findIndex].dflCtgId,
                                            ctgLabel : self.plcyList[findIndex].ctgLabel
                                        }
                                        self.dflCtgList.push(obj);
                                    }
                                })

                                if(this.dflCtgList.length >0){
                                    this.selCtg = this.dflCtgList[0].ctgId
                                }

                                _.forEach(this.plcyList, function(p){
                                    p.vendor = JSON.parse(p.vendor)
                                });

                            }
                        }
                    })

            },
            startColdstartPolicy(){ // 1. compliance 등록 및 실행 2. default category 등록 및 cold start 상태 업데이트
                this.$emit('isFinish', true);
                let data = {
                    'cmpnId': this.curCmpnId,
                    'plcyId': this.selPlcy.plcyId,
                    'rvsnId': this.selPlcy.rvsnId,
                    'doCmpl' : true
                };

                this.pending = true;
                let cmplUrl = `/api/governance/policy/apply`;
                this.http.post(cmplUrl, data)
                    .then( response => {
                        if(response.data.status === 'ok'){
                            this.$emit('isFinish', false);
                            this.pending = false;
                            this.closePopup();
                        }
                    });

                this.finishColdstart();
                this.$router.push('/policy');
                const plcyInfo = {isRecall: true, dflCtgId: this.selPlcy.dflCtgId};
                this.setPolicyHistory(plcyInfo);

            },
            finishColdstart(){
                let finishUrl = `/api/governance/coldstart/finish`;
                let data = {
                    'cmpnId': this.curCmpnId
                }
                this.http.post(finishUrl, data)
                    .then(response=>{
                        this.closePopup();
                    });
            }
        }
    }

</script>

<style scoped>
.coldstart-contetns .title {
    display: inline-flex;
}
.coldstart-contetns .title .icon-vender {
    margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/coldstart/popColdstartStepSecond.vue